module.exports = __webpack_public_path__ + "static/media/RenaultLifeWeb-Bold.10c4269e.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/renault-life/RenaultLifeWeb-Bold.woff
// module id = 929
// module chunks = 0